import { useEffect, useRef, useState } from 'react'

export const useThirdPartyCookieCheck = () => {
  const [isSupported, setIsSupported] = useState<boolean | undefined>(undefined)
  const isSupportedRef = useRef<boolean | undefined>(undefined)
  useEffect(() => {
    const frame = document.createElement('iframe')
    frame.id = '3pc'
    //TODO S3에 static html 로 넣던지 서로 다른 도메인으로 넣기 e.g. www.ringleteens/assets/create-third-party-cookie.html
    frame.src = 'https://chamithrepo.github.io/create-third-party-cookie/' // FIXME : 링글 내 다른 도메인(ringleplus/ringlefront 아닌)으로 교체 필요(`https://${COOKIE_DOMAIN}/check-cookie/index.html`)
    frame.style.display = 'none'
    frame.style.position = 'fixed'
    document.body.appendChild(frame)

    const listen = (event: MessageEvent) => {
      // 메시지 event는 다양한 곳에서 일어나므로 3pcSupported | 3pcUnSupported 가 있는 message인지 잘 확인해야한다.
      if (event.data === '3pcSupported' || event.data === '3pcUnsupported') {
        const _isSupported = event.data === '3pcSupported'
        setIsSupported(_isSupported)
        isSupportedRef.current = _isSupported
        document.body.removeChild(frame)
        window.removeEventListener('message', listen)
      }
    }
    window.addEventListener('message', listen, false)

    // 300ms 까지 확인이 되지 않으면 false 로 리턴할 수 있도록 한다.
    const timer = setTimeout(() => {
      if (isSupportedRef.current === undefined) {
        isSupportedRef.current = false
        setIsSupported(false)
        document.body.removeChild(frame)
        window.removeEventListener('message', listen)
      }
    }, 300)

    return () => {
      clearTimeout(timer)
      window.removeEventListener('message', listen)
    }
  }, [])

  return isSupported
}
